// Polls /version.json and listens for SW updates.
// On full page refresh: auto-applies update and shows "installed" info banner.
// While running: shows prompt banner to reload when new version detected.

const POLL_INTERVAL = 3 * 60 * 1000; // 3 minutes
const SEEN_KEY = 'bwc_seen_version';
const KNOWN_VERSION_KEY = 'bwc_known_version';
let currentVersion = null;
let bannerEl = null;
let polling = false;
let pollIntervalId = null;
let visibilityHandler = null;

function showBanner(text, type = 'update') {
    if (bannerEl) return;

    bannerEl = document.createElement('div');
    bannerEl.className = type === 'installed' ? 'update-banner update-banner--installed' : 'update-banner';

    if (type === 'installed') {
        bannerEl.innerHTML = `
            <span class="update-banner__text">${text}</span>
            <button class="update-banner__close" id="updateDismissBtn" aria-label="Закрыть">&times;</button>
        `;
    } else {
        bannerEl.innerHTML = `
            <span class="update-banner__text">${text}</span>
            <button class="update-banner__btn" id="updateNowBtn">Обновить</button>
            <button class="update-banner__close" id="updateDismissBtn" aria-label="Закрыть">&times;</button>
        `;
    }

    document.body.appendChild(bannerEl);
    requestAnimationFrame(() => bannerEl.classList.add('visible'));

    bannerEl.querySelector('#updateNowBtn')?.addEventListener('click', () => {
        window.location.reload();
    });

    bannerEl.querySelector('#updateDismissBtn').addEventListener('click', () => {
        bannerEl.classList.remove('visible');
        setTimeout(() => { bannerEl.remove(); bannerEl = null; }, 300);
    });

    // Auto-hide "installed" banner after 5 seconds
    if (type === 'installed') {
        setTimeout(() => {
            if (bannerEl) {
                bannerEl.classList.remove('visible');
                setTimeout(() => { if (bannerEl) { bannerEl.remove(); bannerEl = null; } }, 300);
            }
        }, 5000);
    }
}

function showUpdateBanner(newVersion) {
    if (bannerEl) return;

    const versionKey = newVersion || 'sw-update';
    const seen = sessionStorage.getItem(SEEN_KEY);
    if (seen === versionKey) return;

    sessionStorage.setItem(SEEN_KEY, versionKey);
    showBanner('Доступно обновление', 'update');
}

async function checkVersion() {
    try {
        const res = await fetch('/version.json', { cache: 'no-store', mode: 'same-origin' });
        if (!res.ok) return;
        const data = await res.json();

        if (!currentVersion) {
            currentVersion = data.version;

            // On first load, check if version changed since last session
            const knownVersion = localStorage.getItem(KNOWN_VERSION_KEY);
            localStorage.setItem(KNOWN_VERSION_KEY, data.version);

            if (knownVersion && knownVersion !== data.version) {
                // Full refresh loaded a new version — inform user
                showBanner('Обновление установлено', 'installed');
            }
            return;
        }

        if (data.version !== currentVersion) {
            showUpdateBanner(data.version);
        }
    } catch {
        // Network error — if first check failed, use localStorage version as fallback
        // so subsequent polls can still detect changes
        if (!currentVersion) {
            currentVersion = localStorage.getItem(KNOWN_VERSION_KEY) || 'unknown';
        }
    }
}

function listenForSwUpdate() {
    if (!('serviceWorker' in navigator)) return;

    // SW controllerchange and app-updated events mean new SW activated.
    // Suppress these — the version poll handles everything cleanly.
    // Only show prompt if user hasn't refreshed yet.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
        showUpdateBanner(null);
    });

    navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'app-updated') {
            showUpdateBanner(null);
        }
    });
}

export function startUpdateChecker() {
    if (polling) return;
    polling = true;

    listenForSwUpdate();
    setTimeout(checkVersion, 2000);
    pollIntervalId = setInterval(checkVersion, POLL_INTERVAL);

    visibilityHandler = () => {
        if (document.visibilityState === 'visible') {
            checkVersion();
        }
    };
    document.addEventListener('visibilitychange', visibilityHandler);
}

export function stopUpdateChecker() {
    if (pollIntervalId) {
        clearInterval(pollIntervalId);
        pollIntervalId = null;
    }
    if (visibilityHandler) {
        document.removeEventListener('visibilitychange', visibilityHandler);
        visibilityHandler = null;
    }
    polling = false;
}
